import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';
import { FieldErrorComponent } from '../../../ui/forms/field-error/field-error.component';
import { UploadComponent } from '../../../ui/upload/upload.component';
import { UploadResult, UploadState } from '../../../../services/metabi-uploader.service';

@Component({
	selector: 'app-input-control',
	standalone: true,
	imports: [
		AppModule,
		ZorroModule,
		ThirdPartyModule,
		AngularModule,
		FieldLabelComponent,
		FieldErrorComponent,
		UploadComponent,
	],
	templateUrl: './input-control.component.html',
	styleUrls: ['./input-control.component.scss'],
})
export class InputControlComponent extends BaseControlComponent {
	@Input('type') public type: string = 'text';
	@Input('enableUpload') public enableUpload: boolean = false;
	@Input('accept') public accept: string = '';
	@Input('multiple') public multiple: boolean = false;
	@Input('directory') public directory: boolean = false;
	@Input('mimeType') public mimeType: string = '';
	@Input('enablePrevious') public enablePrevious: boolean = false;
	@Input('autocomplete') public autocomplete: string = 'on';
	@Input('disabled') public disabled: boolean = false;
	@Output('showPrevious') public showPrevious: EventEmitter<void> = new EventEmitter<void>();

	ngOnInit() {}

	public onUploadCompleted(event: UploadResult) {
		if (event.progress.state !== UploadState.DONE) {
			return;
		}

		if (!event.result) {
			return;
		}

		let newUrl: string | undefined = undefined; // = event.file || (event.files && event.files[0]) || '';

		if (event.result && !Array.isArray(event.result)) {
			newUrl = event.result.url;
		}

		if (event.result && Array.isArray(event.result) && event.result.length > 0) {
			const h5pJsonFileIfPresent: string | undefined = event.result.find(f => f.url.endsWith('h5p.json'))?.url;

			if (h5pJsonFileIfPresent) {
				newUrl = h5pJsonFileIfPresent.replace('/h5p.json', '.zip');
			}
		}

		this.formGroup?.patchValue({
			[this.formGroupOrControlName]: newUrl,
		});
	}
}
